export default __webpack_public_path__ + "static/media/PrintIconOff.5f6f6c5e.svg";